import React from "react";
import { DataTable } from "./DataTable";
import { Button } from "antd";
import { YhBox } from "@/components/YhBox";
import { useLplModel } from "../lplModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/AppResourceAuthEnum";

export const DataBox = () => {
    const { exportLpl } = useLplModel();

    const action = <>
        <YhAuth resCode={ResourceAuthEnum.J_A_EX}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => exportLpl()}
            >导出</Button>
        </YhAuth>
    </>;

    return (
        <YhBox title="" action={action}>
            <DataTable />
        </YhBox>
    )
}